import { Link } from "react-router-dom";
import AuthShowcase from "./AuthShowcase";
import BrandMark from "../Brand/BrandMark";
import LegalLinks from "../Legal/LegalLinks";
import { AUTH_COLUMN_MIN_HEIGHT } from "./authFieldStyles";

// Every unauthenticated page points somewhere: sign up from the log in screen,
// log in from the rest.
export const SIGN_UP_LINK = { prompt: "New to Globilise?", label: "Sign Up", to: "/create-account" };
export const LOG_IN_LINK = { prompt: "Already have an account?", label: "Sign In", to: "/login" };

// Split screen shell behind every unauthenticated page: brand panel on the
// left, a single centred column on the right. No navbar here - the only way
// out of the column is the link in its top corner. `width` widens that column
// for the longer forms (sign up) without changing anything else.
const AuthLayout = ({ width = "max-w-[380px]", topLink = SIGN_UP_LINK, children }) => (
  <div className="min-h-screen bg-white">
    <div className="lg:grid lg:grid-cols-[46%_1fr]">
      <AuthShowcase />

      <div className={`flex flex-col px-6 py-7 sm:px-10 ${AUTH_COLUMN_MIN_HEIGHT}`}>
        <div className="flex items-center justify-between gap-4">
          {/* The brand panel is hidden below lg, so the mark comes along here. */}
          <Link to="/" className="lg:hidden" aria-label="Globilise">
            <BrandMark />
          </Link>

          {topLink && (
            <p className="ml-auto text-sm text-gray-500">
              {topLink.prompt}{" "}
              <Link
                to={topLink.to}
                className="font-semibold text-brand-600 transition hover:text-brand-700 hover:underline"
              >
                {topLink.label}
              </Link>
            </p>
          )}
        </div>

        <div className="flex flex-1 flex-col justify-center py-10">
          <div className={`mx-auto w-full ${width}`}>{children}</div>
        </div>

        <p className="mx-auto text-center text-xs text-gray-400">
          <LegalLinks />
        </p>
      </div>
    </div>
  </div>
);

export default AuthLayout;
